import { CartActions } from './../../constants/actionType'
import * as chat from './../../service/aimsChat';
const initialState = {
    cartHeader: [],
    cartData: [],
    cartResponse: [],
    isCartOpen: false,
    isYourCartOpen: false,
    cartOfferToggle: {
        isAutopayOffer: true,
        isSpecialOffer: true,
        isSpecialOneTimeOffer: true
    },
    ProfileDataProduct: null,
    ProfileTVProduct: null,
    ProfileVoiceProduct: null,
    ProfileRouterProduct: null,
    ProfileAPProduct: null,
    ProfileVRoomProduct: null,
    ProfileVfutureProduct: null,
    ProfileFneProduct: null,
    ProfileChannelProduct: null,
    ProfileVasProduct: null,
    profilePerksProducts:null,
    splitBillTab: 0,
    cartOrderDetail: null,
    autoPayinCart: false,
    isCartUpdated: false,
    isCartCleared: false,
    cartMyPlanHeader: {
        "title": "",
        "totalPrice": "",
        "priceDescription": "",
        "description": "",
        "contract": ""
    },
    isAutoPayOnProfile: false,
    isEmpDiscOnCsr: false,
    isAffinityDiscOnCsr: false,
    ProfileDctProduct: null,
    ProfileCeAppProduct: null,
    ProfileBoltonSpeedProduct: null,
    qamInProfile: false,
    profileSpeedCode: null,
    classicTvInProfile: false,
    legacyTVInProfile: false,
    isFiosTvOneInProfile: false,
    dctOrCcInProfile:false,
    currentPlanTabSelected: false,
    showOneTimeCharges: false,
    dealsAtWorkFlag: false
}

function ecProfileCart(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_PROFILE_CART':
            if (action.value.cartData) {
                chat.setCartChat(action.value.cartData, false);
            }
            return Object.assign({}, state, {
                cartResponse: action.value.cartResponse,
                cartHeader: action.value.cartHeader,
                cartData: action.value.cartData,
                cartOrderDetail: action.value.cartOrderDetail,
                cartMyPlanHeader: action.value.cartMyPlanHeader
            })

        // case CartActions.toggleCart:
        //     return Object.assign({}, state, {
        //         isCartOpen: !state.isCartOpen
        //     })
        case CartActions.toggleYourCart:
            return Object.assign({}, state, {
                isYourCartOpen: !state.isYourCartOpen
            })
        case CartActions.toggleOffers:
            if (action.value === "AutoPayToggle") {
                let autopayOffer = Object.assign({}, state.cartOfferToggle, {
                    isAutopayOffer: !state.cartOfferToggle.isAutopayOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: autopayOffer
                })
            }
            if (action.value === "SpecialOfferToggle") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOffer: !state.cartOfferToggle.isSpecialOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer
                })
            }
            if (action.value === "SpecialOfferOneTimeToggles") {
                let specialOffer = Object.assign({}, state.cartOfferToggle, {
                    isSpecialOneTimeOffer: !state.cartOfferToggle.isSpecialOneTimeOffer,
                })
                return Object.assign({}, state, {
                    cartOfferToggle: specialOffer
                })
            }
            break;
        case "EMPTYCARTSTATE":
            return initialState
        case CartActions.splitBillTab:
            return Object.assign({}, state, {
                splitBillTab: action.value
            })
        case CartActions.clearcartstate:
            return initialState
        case 'AUTOPAYINPROFILE':
            return Object.assign({}, state, {
                autoPayinCart: action.value
            })
        case 'ISCARTUPDATED':
            return Object.assign({}, state, {
                isCartUpdated: action.value
            })
        case "UPDATE_CSRDATA":
            return Object.assign({}, state, {
                ProfileDataProduct: action.value
            })

        case "UPDATE_CSR_BOLTONSPEED":
            return Object.assign({}, state, {
                ProfileBoltonSpeedProduct: action.value
            })
        case "UPDATE_CSRTV":
            return Object.assign({}, state, {
                ProfileTVProduct: action.value
            })
        case "UPDATE_CSRVOICE":
            return Object.assign({}, state, {
                ProfileVoiceProduct: action.value
            })
        case "UPDATE_CSRROUTER":
            return Object.assign({}, state, {
                ProfileRouterProduct: action.value
            })
        case "UPDATE_CSRAP":
            return Object.assign({}, state, {
                ProfileAPProduct: action.value
            })
        case "UPDATE_CSRPERKS":
            return Object.assign({}, state, {
                profilePerksProducts: action.value
            })
        case "UPDATE_CSRFNE":
            return Object.assign({}, state, {
                ProfileFneProduct: action.value
            })
        case "UPDATE_CSRSTB":
            return Object.assign({}, state, {
                ProfileVRoomProduct: action.value
            })
        case "UPDATE_CSRVROOM":
            return Object.assign({}, state, {
                ProfileVfutureProduct: action.value
            })
        case "UPDATE_CSRVAS":
            return Object.assign({}, state, {
                ProfileVasProduct: action.value
            })
        case 'ISAUTOPAYONPROFILE':
            return Object.assign({}, state, {
                isAutoPayOnProfile: action.value
            })
        case 'IS_EMP_DISC_ONCSR':
            return Object.assign({}, state, {
                isEmpDiscOnCsr: action.value
            })
        case 'IS_AFFINITY_DISC_ONCSR':
            return Object.assign({}, state, {
                isAffinityDiscOnCsr: action.value
            })
        case "UPDATE_CSRDCT":
            return Object.assign({}, state, {
                ProfileDctProduct: action.value
            })
        case "UPDATE_CSRCHANNEL":
                return Object.assign({}, state, {
                    ProfileChannelProduct: action.value
            }) 
        case "UPDATE_CSRCEAPP":
            return Object.assign({}, state, {
                ProfileCeAppProduct: action.value
        })
        case 'QAM_IN_PROFILE':
            return Object.assign({}, state, {
                qamInProfile: action.value
            }) 
        case 'CLASSIC_TV_IN_PROFILE':
            return Object.assign({}, state, {
                classicTvInProfile: action.value
            })  
        case 'PROFILE_SPEEDCODE':
            return Object.assign({}, state, {
                profileSpeedCode: action.value
            })
        case 'LEGACY_TV_IN_PROFILE':
            return Object.assign({}, state, {
                legacyTVInProfile: action.value
            }) 
        case 'LEGACY_EQUIP_PACK_ON_PROFILE':
            return Object.assign({}, state, {
                legacyEquipPackOnprofile: action.value
            })
        case 'FIOS_TV_ONE_IN_PROFILE':
            return Object.assign({}, state, {
                isFiosTvOneInProfile: action.value
            })
        case 'DCT_OR_CC_IN_PROFILE':
            return Object.assign({}, state, {
                dctOrCcInProfile: action.value
            }) 
        case 'CURRENT_CART_TAB_SELECTED':
            return Object.assign({}, state, {
                currentPlanTabSelected: action.value
                })
        case 'TOGGLE_ONE_TIME_CHARGES_ON_PROFILE':
            return Object.assign({}, state, {
                showOneTimeCharges: !state?.showOneTimeCharges
            })
        case 'DEALS_AT_WORK_FLAG':
            return Object.assign({}, state, {
                dealsAtWorkFlag: action.value
            })
        default:
            return state
    }
}

export default ecProfileCart
